"use client"

import type React from "react"

interface LivesDisplayProps {
  lives: number
  className?: string
  style?: React.CSSProperties
}

export const LivesDisplay = ({ lives, className, style }: LivesDisplayProps) => {
  return (
    <div
      id="lives-display"
      className={
        className || "bg-black bg-opacity-60 text-white pl-4 pr-2 py-1 rounded-lg flex items-center gap-1.5 relative"
      }
      style={style}
    >
      <div className="absolute -left-1.5 top-1/2 -translate-y-1/2">
        <img
          src="/images/icon-lives.png"
          alt="Lives"
          width={28}
          height={28}
          className="drop-shadow-lg"
          style={{ imageRendering: "pixelated" }}
        />
      </div>
      <span className="font-bold text-white text-sm ml-2 pl-1.5">{lives}</span>
    </div>
  )
}
